import React from 'react';
import { INavigationItemProps, NavigationItem } from '../NavigationItem';
import { FlexRow } from '../../FlexRow';

export interface ISubNavigationProps {
  active?: string;
  children?: (React.ReactElement<INavigationItemProps> | undefined)[];
  centered?: boolean;
}

export const SubNavigation = React.forwardRef<HTMLDivElement, ISubNavigationProps>(
  ({ children, active, centered = true }, ref) => {
    const itemsToUse = children || [];
    const navigationItems = itemsToUse.map(
      (t, i) =>
        t && (
          <NavigationItem
            {...t.props}
            key={i}
            showUnderline={true}
            isActive={t.props.isActive || t.props.text === active}
          />
        )
    );

    return (
      <FlexRow verticalAlign={'center'} textAlign={'center'} justifyContent={centered ? 'center' : 'start'} ref={ref}>
        {navigationItems}
      </FlexRow>
    );
  }
);
